import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";

type MetaContextValue = {
  hasUserAuthenticated: boolean;
  setHasUserAuthenticated: Dispatch<SetStateAction<boolean>>;
};

const MetaContext = createContext<MetaContextValue | null>(null);

export const MetaProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [hasUserAuthenticated, setHasUserAuthenticated] = useState(false);
  const value = useMemo(
    () => ({
      hasUserAuthenticated,
      setHasUserAuthenticated,
    }),
    [hasUserAuthenticated],
  );

  return <MetaContext.Provider value={value}>{children}</MetaContext.Provider>;
};

export const useMeta = () => {
  const metaContext = useContext(MetaContext);

  if (metaContext === null) {
    throw new Error("useMeta must be used within a MetaProvider");
  }

  return metaContext;
};
